import axios from "axios";

const api = axios.create({
    baseURL: window.config.URL_API
  });

export const CheckPostAward = async (requestData) => {
  
    return await api.post("/EligibilityCheck",requestData);
};

export const CheckAward = async (isTz,number) => {
    return await api.get(`/EligibilityCheck/${isTz}/${number}`);
};
